import { motion } from 'framer-motion';

import { FADE_IN_OUT, TEXTS } from '@/utils';

export const NotFoundResult = ({ title }: { title?: string }) => {
  return (
    <motion.div animate={'show'} initial={'hide'} variants={FADE_IN_OUT}>
      <div className="pl-[20px] pr-[15px] lg:pr-[30px] py-[16px] space-y-4">
        <div className="flex items-center justify-center">
          <svg
            fill="none"
            height="47"
            viewBox="0 0 47 47"
            width="47"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="23.125" cy="23.125" fill="#E3EAFF" r="23.125" />
            <path
              clipRule="evenodd"
              d="M23.2068 14.194C18.2293 14.194 14.1942 18.229 14.1942 23.2066C14.1942 28.1841 18.2293 32.2192 23.2068 32.2192C28.1843 32.2192 32.2194 28.1841 32.2194 23.2066C32.2194 18.229 28.1843 14.194 23.2068 14.194ZM12.1914 23.2066C12.1914 17.1229 17.1232 12.1912 23.2068 12.1912C29.2904 12.1912 34.2222 17.1229 34.2222 23.2066C34.2222 29.2902 29.2904 34.222 23.2068 34.222C17.1232 34.222 12.1914 29.2902 12.1914 23.2066Z"
              fill="#2855C6"
              fillRule="evenodd"
            />
            <path
              clipRule="evenodd"
              d="M19.6746 25.4009C20.4737 24.8198 21.6776 24.208 23.2052 24.208C24.7329 24.208 25.9368 24.8198 26.7359 25.4009C27.1373 25.6929 27.4477 25.9848 27.66 26.2064C27.7666 26.3176 27.8497 26.4124 27.9085 26.4824C27.9379 26.5174 27.9612 26.5463 27.9785 26.5681L27.9998 26.5954L28.0071 26.6049L28.0098 26.6085L28.011 26.61C28.011 26.61 28.012 26.6114 27.2258 27.201L28.012 26.6114C28.3438 27.0538 28.2541 27.6815 27.8117 28.0133C27.3706 28.3441 26.7455 28.2561 26.4129 27.8172L26.4082 27.8113C26.4023 27.8038 26.3909 27.7897 26.3744 27.7699C26.3412 27.7304 26.2874 27.6687 26.214 27.5921C26.0665 27.4382 25.8449 27.2294 25.5579 27.0207C24.98 26.6004 24.1811 26.2108 23.2052 26.2108C22.2294 26.2108 21.4305 26.6004 20.8526 27.0207C20.5656 27.2294 20.344 27.4382 20.1965 27.5921C20.1231 27.6687 20.0693 27.7304 20.0361 27.7699C19.1997 28.7143 18.508 28.0674 18.5021 28.0749M18.5021 28.0749C17.701 27.474 18.399 26.6107 18.399 26.6107L18.4007 26.6085L18.4034 26.6049L18.4107 26.5954L18.432 26.5681C18.4492 26.5463 18.4726 26.5174 18.502 26.4824C18.5608 26.4124 18.6439 26.3176 18.7505 26.2064C18.9628 25.9848 19.2732 25.6929 19.6746 25.4009"
              fill="#2855C6"
              fillRule="evenodd"
            />
            <path
              clipRule="evenodd"
              d="M19.2031 20.2023C19.2031 19.6493 19.6515 19.2009 20.2045 19.2009H20.2145C20.7676 19.2009 21.2159 19.6493 21.2159 20.2023C21.2159 20.7554 20.7676 21.2037 20.2145 21.2037H20.2045C19.6515 21.2037 19.2031 20.7554 19.2031 20.2023Z"
              fill="#2855C6"
              fillRule="evenodd"
            />
            <path
              clipRule="evenodd"
              d="M25.2109 20.2023C25.2109 19.6493 25.6593 19.2009 26.2123 19.2009H26.2224C26.7754 19.2009 27.2238 19.6493 27.2238 20.2023C27.2238 20.7554 26.7754 21.2037 26.2224 21.2037H26.2123C25.6593 21.2037 25.2109 20.7554 25.2109 20.2023Z"
              fill="#2855C6"
              fillRule="evenodd"
            />
          </svg>
        </div>
        <p className="text-lg text-center text-gdt-gray">
          {title || TEXTS.playerNotFound}
        </p>
      </div>
    </motion.div>
  );
};
